<script setup lang="ts">
import type { ModalRenderEntry } from '~/composables/useModal'

const modal = defineProps<{
  stack: ModalRenderEntry[]
  closeById: (id: number, value?: unknown) => void
}>()

const getComponentBindings = (entry: ModalRenderEntry) => {
  const bindings: Record<string, unknown> = {
    ...entry.props,
    ...entry.listeners,
  }

  Object.entries(entry.models).forEach(([modelName, modelRef]) => {
    bindings[modelName] = modelRef.value
    bindings[`onUpdate:${modelName}`] = (value: unknown) => {
      modelRef.value = value

      if (modelName === 'open' && value === false) {
        modal.closeById(entry.id)
      }
    }
  })

  return bindings
}
</script>

<template>
  <component
    v-for="entry in modal.stack"
    :key="entry.id"
    :is="entry.component"
    v-bind="getComponentBindings(entry)"
  />
</template>

<style scoped></style>
